import BaseApi from './base/BaseApi';

export default class CrmLeadChangeApi extends BaseApi {
  static entityName = 'crm_lead_changes';
}
